module.exports = __webpack_public_path__ + "static/media/icon-train-update.91365f32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-train-update.svg
// module id = 184
// module chunks = 0